export const JOB_SEARCH_STATE = ['activelySearching', 'openOpportunities', 'dreamjobOnly', 'notSearching'];

export type JobSearchStates = typeof JOB_SEARCH_STATE[number];
